// src/services/reportService.js
import api from './api';
import { downloadBlobFile } from './nativeFileService';

const reportService = {
  // Obtener reportes
  getProjectsReport: async (filters) => {
    const response = await api.get('/reports/projects', { params: filters });
    return response.data;
  },

  getClientsReport: async (filters) => {
    const response = await api.get('/reports/clients', { params: filters });
    return response.data;
  },

  getTasksReport: async (filters) => {
    const response = await api.get('/reports/tasks', { params: filters });
    return response.data;
  },

  getFinancesReport: async (filters) => {
    const response = await api.get('/reports/finances', { params: filters });
    return response.data;
  },

  getUsersReport: async () => {
    const response = await api.get('/reports/users');
    return response.data;
  },

  // Exportar
  exportToPDF: async (reportType, data) => {
    const response = await api.post('/reports/export/pdf', { reportType, data }, {
      responseType: 'blob'
    });
    
    await downloadBlobFile(response.data, {
      fileName: `report_${reportType}_${Date.now()}.pdf`,
      mimeType: 'application/pdf'
    });
  },

  exportToExcel: async (reportType, data) => {
    const response = await api.post('/reports/export/excel', { reportType, data }, {
      responseType: 'blob'
    });
    
    await downloadBlobFile(response.data, {
      fileName: `report_${reportType}_${Date.now()}.xlsx`,
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
  }
};

export default reportService;
